import { render, staticRenderFns } from "./GlobalDisclaimer.vue?vue&type=template&id=e60e35aa&scoped=true"
import script from "./GlobalDisclaimer.vue?vue&type=script&lang=js"
export * from "./GlobalDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./GlobalDisclaimer.vue?vue&type=style&index=0&id=e60e35aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60e35aa",
  null
  
)

export default component.exports